// extracted by mini-css-extract-plugin
export default {"view":"view--QugXb0TBe5"};